import { render } from "./ViewsHome.vue?vue&type=template&id=606fab4d"
import script from "./ViewsHome.vue?vue&type=script&lang=js"
export * from "./ViewsHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__